import React from "react";
import ProductsContainer from "../containers/ProductsContainer";
import HeaderContainer from "../containers/HeaderContainer";
import HeaderNavContainer from "../containers/HeaderNavContainer";
import {buildRoute} from "../utils/routerUtils.ts";
import {angularRouterHost} from "../utils/angularManagerUtils";
import {ROUTES, STUDIO_DISABLE_LIBRARIES_LINK} from "../utils/constants";
import {NavLink, Link, withRouter} from "react-router-dom";
import "../../styles/Header.css"

const setBreadCrumb = () => {
  if (localStorage.getItem(STUDIO_DISABLE_LIBRARIES_LINK) === "true") {
    return <></>
  } else {
    return (<Link className={"breadcrumb"} to={ROUTES.PROJECTS}>Libraries</Link>);
  }
};

const Products = (props) => {

  return (
    <div>
      <HeaderContainer>
        <HeaderNavContainer breadcrumb={setBreadCrumb()} activeItem={0}>
          <NavLink to={buildRoute(ROUTES.PRODUCTS, {":projectId": props.match.params.projectId})}>Products</NavLink>
          <a href={`${angularRouterHost()}${props.match.params.projectId}/templates`}>Templates</a>
        </HeaderNavContainer>
      </HeaderContainer>
      <ProductsContainer />
    </div>
  )
}

export default withRouter(Products);
